import React, { useState, useEffect, Fragment } from 'react';
import {
    Row,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    Spinner,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    InputGroup,
    InputGroupAddon,
    TabPane,
    TabContent,
    CardHeader,
} from 'reactstrap';
import { Colxx } from '../../../../../../../components/common/CustomBootstrap';
import Validation from '../../../../../../../components/Validation';
import { gAPI_Promo_Codes_List, postAPI_Create_Promo_Codes } from '../../../../../../../constants/APIs';
import Pagination from '../../../../../../../containers/pages/Pagination';
import { AxiosAPI, getGroupID } from '../../../../../../../helpers/AxiosAPI';
import PromoCodeForm from './PromoCodeForm';
import PromoListItem from './PromoListItem';
function PromoCodes({ propertyId, propertyVouchers, propertydata }) {
    const statusOptions = [
        { column: 'All', label: 'All' },
        { column: 'Active', label: 'Active' },
        { column: 'ActiveMembers', label: 'Active - Members Only' },
        { column: 'Draft', label: 'Draft' },
        { column: 'Inactive', label: 'Inactive' },
        { column: 'Archived', label: 'Archived' },
      ];
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [TotalItems, setTotalItems] = useState(0);
    const [TotalPages, setTotalPages] = useState(1);
    const [pageSizes, setpageSizes] = useState([10, 15, 20, 25]);
    const [promoCode, ShowPromoCode] = useState(false);
    const [promoList, setPromoList] = useState([]);
    const [codeSearch, setCodeSearch] = useState('');
    const [currentPage, setcurrentPage] = useState(1);
    const [SelectedPageSize, setSelectedPageSize] = useState(10);
    const [codeStatus, setCodeStatus] = useState({
        column: 'All',
        label: 'All',
    });

    useEffect(() => {
        loadPromoCodes();
    }, [propertyId, codeSearch, currentPage, SelectedPageSize, codeStatus]);

    const loadPromoCodes = () => {
        AxiosAPI({
            methhod: 'get',
            url: `${gAPI_Promo_Codes_List}?groupId=${getGroupID()}&propertyId=${propertyId}&search=${codeSearch}&status=${codeStatus.column
                }&pageNumber=${currentPage}&pageSize=${SelectedPageSize}`,
        }).then((res) => {                
                setPromoList(res.data.promoCodes);
                //setLoading(false);
               // setShowCreateVoucherButton(true);
                setTotalItems(res.data.totalItems);
                setTotalPages(res.data.totalPages);
            }).catch((err) => null);
    }

    const startIndex = (currentPage - 1) * SelectedPageSize;
    const endIndex = currentPage * SelectedPageSize;

    const changePageSize = (size) => {
        setSelectedPageSize(size);
        setcurrentPage(1);
     };
    
    const handlePromoCode = (data) => {
        AxiosAPI({
            method: 'post',
            url: `${postAPI_Create_Promo_Codes}`,
            data: data,
        }).then((res) => {            
            if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                && res.data.Messages !== null && res.data.Messages.length > 0) {
                setMsg(res.data.Messages);
                setOpen(true);
            }
            else {
                ShowPromoCode(!promoCode);
                loadPromoCodes();
            }
        });

    };

    const onChangePage = (page) => {
        setcurrentPage(page);

    };

    return (
        <Fragment>
            <Card className="mb-4">
                <CardBody>
                    <Row>
                        {promoCode &&
                            <PromoCodeForm formLabel={"Promo Code"} handleSubmit={handlePromoCode} vouchers={propertyVouchers} isVisible={promoCode} toggle={() => ShowPromoCode(!promoCode)}>
                            </PromoCodeForm>}
                        <div className='col-md-12 my-2'>
                            <Button
                                color="primary"
                                outline
                                size="lg"
                                onClick={() => {
                                    ShowPromoCode(!promoCode);
                                }}
                                style={{ width: '100%', borderRadius: '6px' }}
                            >
                                + Add Promo Code
                            </Button>
                        </div>
                    </Row>
                    <Row>
                        <Colxx xxs="4">
                            <div className="mb-2">
                                <div className="d-block d-md-inline-block">
                                    <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                                        <DropdownToggle caret color="outline-dark" size="xs">
                                            Status
                                            {" "}{codeStatus.label}
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            {statusOptions.map((order, index) => {
                                                return (
                                                    <DropdownItem
                                                        key={index}
                                                        onClick={() => setCodeStatus(order)}
                                                    >
                                                        {order.label}
                                                    </DropdownItem>
                                                );
                                            })}
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                    {/* <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                                        <input
                                            type="text"
                                            name="keyword"
                                            id="search"
                                            placeholder="Search"
                                            onKeyPress={(e) => setCodeSearch(e.target.value)}
                                        />
                                    </div> */}
                                </div>
                            </div>
                        </Colxx>
                        <Colxx xxs="8">
                            <div className="float-md-right">
                                <span className="text-muted text-small mr-1">{`${startIndex}-${endIndex} of ${TotalItems} `}</span>
                                <UncontrolledDropdown className="d-inline-block">
                                    <DropdownToggle caret color="outline-dark" size="xs">
                                        {SelectedPageSize}
                                    </DropdownToggle>
                                    <DropdownMenu right>
                                        {pageSizes.map((size, index) => {
                                            return (
                                                <DropdownItem
                                                    key={index}
                                                    onClick={() => changePageSize(size)}
                                                >
                                                    {size}
                                                </DropdownItem>
                                            );
                                        })}
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </div>
                        </Colxx>
                        <div className='col-md-12 my-3'>
                            {promoList !== undefined && promoList.length > 0 && promoList.map((m) =>
                                <PromoListItem item={m} vouchers={propertyVouchers} currency={propertydata.currency} LoadPromoCodes={loadPromoCodes}></PromoListItem>
                            )}
                            <Pagination
                                currentPage={currentPage}
                                totalPage={TotalPages}
                                onChangePage={(i) => onChangePage(i)}
                            />
                        </div>

                    </Row>
                </CardBody>
            </Card>
            <Validation open={open} messages={msg} toggle={()=>{setOpen(!open)}}></Validation>
        </Fragment>
    );
}

export default PromoCodes;